import React from 'react';
import jwtDecode from 'jwt-decode';
import { DropdownButton, MenuItem } from 'react-bootstrap';
import { Modal } from 'hyperdb-utils';
import api from 'api';
import { ModalEmailAction } from '../../common';
import { FILESTORE_URL } from '../../../../../config';

class ItemActions extends React.Component {
  constructor(props) {
    super(props);
    this.handleEdit = this.handleEdit.bind(this);
    this.handleToggleModalDelete = this.handleToggleModalDelete.bind(this);
    this.handleConfirmDelete = this.handleConfirmDelete.bind(this);
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.deleteSuccessful) {
      this.props.api.routing.redirect(this.props.router, '/daily-rental/reservations');
    }
    if (nextProps.actionSuccessful) {
      this.props.api.reservation.setData({ selectedAction: null, actionSuccessful: false });
      if (this.props.onActionSuccessful) this.props.onActionSuccessful();
    }
  }
  componentWillUnmount() {
    this.props.api.reservation.setData({
      deleteSuccessful: false,
      showModalDelete: false,
      successMessage: null,
      errorMessage: null,
      selectedAction: null,
      actionSuccessful: false,
    });
  }
  render() {
    const reservation = this.props.reservation;
    return (
      <div style={{display: 'inline-block'}}>
        <DropdownButton title={ <i className={ `fas fa-cog`} /> } pullRight bsSize="small" id="Menu actions">
          <MenuItem onClick={ this.handleEdit }>Edit</MenuItem>
          <MenuItem onClick={ this.handleToggleModalDelete.bind(this, true) }>Delete</MenuItem>
          <MenuItem onClick={ this.handleSelectItemAction.bind(this, 'send_email') }>Send an email</MenuItem>
          {
            reservation.available && ['new', 'requested', 'offered'].includes(reservation.status) && !reservation.error_code
              ? <MenuItem onClick={ this.handleSelectItemAction.bind(this, 'accept') }>Accept</MenuItem>
              : null
          }
          {
            reservation.available && reservation.status === 'new' && !reservation.error_code
              ? <MenuItem onClick={ this.handleSelectItemAction.bind(this, 'offer') }>Offer</MenuItem>
              : null
          }
          {
            reservation.status === 'requested'
              ? <MenuItem onClick={ this.handleSelectItemAction.bind(this, 'reject') }>Reject</MenuItem>
              : null
          }
          {
            !reservation.available && ['requested', 'offered'].includes(reservation.status)
              ? <MenuItem onClick={ this.handleSelectItemAction.bind(this, 'alternative') }>Suggest an alternative</MenuItem>
              : null
          }
          {
            reservation.status === 'offered'
              ? <MenuItem onClick={ this.handleSelectItemAction.bind(this, 'abort') }>Abort</MenuItem>
              : null
          }
          {
            reservation.status === 'accepted' && !reservation.error_code
              ? <MenuItem onClick={ this.handleSelectItemAction.bind(this, 'confirm') }>Confirm</MenuItem>
              : null
          }
          {
            reservation.status === 'accepted' && !reservation.error_code
              ? <MenuItem onClick={ this.handleSelectItemAction.bind(this, 'resend_prebooking_email') }>Re-send prebooking email</MenuItem>
              : null
          }
          {
            reservation.status === 'confirmed'
              ? <li role="presentation">
                  <a href={ `${this.pdfBaseUrl()}/reservations/${reservation.reference}/generate-pdf?set_printed=true`} target="_blank" role="menuitem">Print confirmation</a>
                </li>
              : null
          }
          {
            reservation.status === 'confirmed'
              ? <MenuItem onClick={ this.handleSelectItemAction.bind(this, 'resend_confirmation') }>Re-send confirmation email</MenuItem>
              : null
          }
          {
            ['accepted', 'confirmed'].includes(reservation.status)
              ? <MenuItem onClick={ this.handleSelectItemAction.bind(this, 'cancel') }>Cancel</MenuItem>
              : null
          }
          {
            ['accepted', 'confirmed'].includes(reservation.status) && !reservation.deposit_paid && !reservation.error_code
              ? <MenuItem onClick={ this.handleSelectItemAction.bind(this, 'add_payment') }>Add a payment</MenuItem>
              : null
          }
          {
            ['rejected', 'aborted', 'canceled'].includes(reservation.status)
              ? <MenuItem onClick={ this.handleSelectItemAction.bind(this, 'reactivate') }>Re-activate</MenuItem>
              : null
          }
          {
            reservation.error_code
              ? <MenuItem onClick={ this.handleSelectItemAction.bind(this, 'remove_error') }>Remove error</MenuItem>
              : null
          }
        </DropdownButton>
        {
          this.props.showModalDelete
            ? <Modal
                show={ true }
                onClose={ this.handleToggleModalDelete.bind(this, false) }
                title="Delete"
                loading={ this.props.loading }
                onAccept={ this.handleConfirmDelete }
                labelConfirm="Delete">
                  <span>Are you sure you want to delete this object ?</span>
              </Modal>
            : null
        }
        {
          this.props.selectedAction
            ? <ModalEmailAction
                { ...this.propsForModalAction(this.props.selectedAction) }
                reservation={ this.props.reservation }
                repliedMessageId={ this.props.repliedMessageId }
                processingAction={ this.props.loading }
                selectedAction={ this.props.selectedAction }
                onClose={ this.handleSelectItemAction.bind(this, null) }
                actionSuccessful={ this.props.postDataSuccessful } />
            : null
        }
      </div>
    );
  }

  pdfBaseUrl() {
    const { currentUser } = this.props.api.getState('auth');
    const decoded = jwtDecode(currentUser.jwt);
    return `${FILESTORE_URL}/${decoded.client_id}`;
  }

  handleEdit() {
    this.props.api.routing.redirect(this.props.router, `/daily-rental/reservations/${this.props.reservation.id}/edit`);
  }
  handleToggleModalDelete(bool) {
    this.props.api.reservation.setData({ showModalDelete: bool });
  }
  handleConfirmDelete() {
    this.props.api.reservation.deleteObject(this.props.reservation);
  }


  handleSelectItemAction(selectedAction) {
    if (selectedAction === 'add_payment') {
      const newPayment = { amount: this.props.objectData.deposit, transaction_date: moment().format('YYYY-MM-DD') };
      this.props.api.payment.setData({ objectData: newPayment });
    } else if (selectedAction === 'alternative') {
      const queryParams = {
        reference: this.props.objectData.reference,
        arrival_date: this.props.objectData.arrival_date,
        departure_date: this.props.objectData.departure_date,
        nb_adults: this.props.objectData.nb_adults || 0,
        nb_young_adults: this.props.objectData.nb_young_adults || 0,
        nb_children: this.props.objectData.nb_children || 0,
        nb_young_children: this.props.objectData.nb_young_children || 0,
        ignore_conditions: this.props.objectData.ignore_conditions ? 1 : 0,
      };
      const queryString = Object.keys(queryParams).map(attr => `${attr}=${queryParams[attr]}`).join('&');
      this.props.api.routing.redirect(this.props.router, `/daily-rental/availabilities/search?${queryString}`);
    } else {
      this.props.api.reservation.setData({ selectedAction, postDataSuccessful: false });
    }
  }
  propsForModalAction(action) {
    let templateCode;
    let templateId;
    let title;
    let onSubmit;
    let forceSendEmail = false;
    let noEmail = false;
    let confirmMessage;
    switch (action) {
    case 'send_email':
      forceSendEmail = true;
      templateCode = '101';
      title = 'Send email';
      onSubmit = this.props.api.reservation.sendEmail;
      break;
    case 'accept':
      templateCode = '130';
      title = 'Accept';
      onSubmit = this.props.api.reservation.accept;
      break;
    case 'offer':
      templateCode = '120';
      title = 'Offer';
      onSubmit = this.props.api.reservation.offer;
      break;
    case 'reject':
      templateCode = this.props.objectData.available ? '101' : '114';
      title = 'Reject';
      onSubmit = this.props.api.reservation.reject;
      break;
    /* case 'alternative':
      break;*/
    case 'abort':
      templateCode = '101';
      title = 'Abort';
      onSubmit = this.props.api.reservation.abort;
      break;
    case 'confirm':
      templateCode = '135';
      title = 'Confirm';
      onSubmit = this.props.api.reservation.confirm;
      break;
    case 'resend_confirmation':
      forceSendEmail = true;
      templateCode = '135';
      title = 'Re-send confirmation';
      onSubmit = this.props.api.reservation.confirm;
      break;
    case 'resend_prebooking_email':
      title = 'Re-send prebooking email';
      forceSendEmail = true;
      templateCode = '130';
      onSubmit = this.props.api.reservation.sendEmail;
      break;
    case 'cancel':
      templateCode = this.props.reservation.deposit_paid ? '150' : '151';
      title = 'Cancel';
      onSubmit = this.props.api.reservation.cancel;
      break;
    case 'reactivate':
      noEmail = true;
      confirmMessage = 'Are you sure you want to re-activate this reservation ?';
      title = 'Re-activate';
      onSubmit = this.props.api.reservation.reactivate;
      break;
    case 'remove_error':
      noEmail = true;
      confirmMessage = 'Are you sure you want to remove this error ?';
      title = 'Remove error';
      onSubmit = this.props.api.reservation.removeError;
      break;
    }
    return { templateCode, templateId, title, onSubmit, forceSendEmail, noEmail, confirmMessage };
  }
}

export default api.connect(ItemActions, 'reservation');



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/reservation/containers/ItemActions.jsx